/**
 * GA4 引导（从 index.html 内联脚本迁出；CSP script-src 去 'unsafe-inline' 的前提，
 * 见 apps/worker/src/middleware/security.ts）。
 *
 * 行为与原内联版本逐行等价：
 * - VITE_GA_ID 未配置（本地 dev / 测试构建）→ id 正则不匹配，整段跳过，
 *   window.gtag 不存在 → lib/analytics.ts 全部 no-op（口径不变）。
 * - send_page_view=false：page_view 由 React 侧统一上报（components/Analytics.tsx）。
 * - gtag.js（~164KB）延迟到首次真实交互或 5s 空闲才拉取（LCP 优化）。
 * - dataLayer 桩在本模块求值时即就绪——本模块必须是 main.tsx 的首个 import，
 *   早于任何 React 埋点触发，延迟期内的 page_view/事件入队照常回放。
 */

const GA_ID = import.meta.env.VITE_GA_ID;

function bootGa(): void {
  if (typeof window === "undefined") return;
  if (!/^G-[A-Z0-9]+$/.test(GA_ID ?? "")) return;

  const w = window as unknown as {
    dataLayer?: unknown[][];
    gtag?: (...args: unknown[]) => void;
  };
  w.dataLayer = w.dataLayer ?? [];

  // dataLayer 条目推数组（官方代码段为 arguments 对象；gtag.js 内部按
  // Array.prototype.slice 解析，数组与 arguments 同构，行为等价）
  function gtag(...args: unknown[]): void {
    w.dataLayer?.push(args);
  }
  w.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });

  let loaded = false;
  function load(): void {
    if (loaded) return;
    loaded = true;
    clearTimeout(timer);
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;
    document.head.appendChild(s);
  }
  const timer = setTimeout(load, 5000);
  for (const ev of ["pointerdown", "keydown", "scroll", "touchstart"]) {
    window.addEventListener(ev, load, { capture: true, once: true });
  }
}

bootGa();
